import React, { ReactElement, useContext, useState } from 'react'
import { Context } from '@/components/Context'
import { ArtData } from '@/database/art'
import Button from '@/components/Button'
import { ArtState } from '@/database/types'

const portfolioDataOptions = (portfolioData: ArtData[], currentAccount: string | null, currentTokenId: number) => {
    return portfolioData
        ?.filter((artData) => artData.tokenId && artData.art.title && artData.art.currentOwner === currentAccount)
        .filter((ad) => ad.art.nft.tokenId !== currentTokenId) // Don't allow to claim itself
        .filter(
            (artData) =>
                artData.art.state !== ArtState.FORCED_AUCTION &&
                artData.art.state !== ArtState.AUCTION &&
                artData.art.state !== ArtState.FOR_SALE &&
                artData.art.state !== ArtState.HIDDEN,
        )
        .map((artData) => (
            <option key={artData.tokenId} title={artData.art.title} value={artData.tokenId}>
                {'(' + (artData.claimPower - artData.totalClaims) + ') ' + artData.art.title}
            </option>
        ))
}

const Claim = ({ artData }: { artData: ArtData }): ReactElement => {
    const { accountSignature, currentAccount, claimHandler, portfolioData } = useContext(Context)
    const [claimPower, setClaimPower] = useState(0.0)
    const [claimValue, setClaimValue] = useState('')
    const [castingArtId, setCastingArtId] = useState(-1)

    const handleClaimInputChange = (event: { target: { value: string } }) => {
        const input = event.target.value.replace(',', '.') // Normalize input

        // Check if the last character is a dot or if the input is just a dot
        const endsWithDot = input.endsWith('.') || input === '.'

        // Use a regular expression to validate if the input is in a correct numeric format (including dots)
        const isValidNumericInput = /^(\d+\.?\d*|\.\d+)$/.test(input)

        if (endsWithDot || isValidNumericInput) {
            // Directly update the state with the input if it's a valid numeric input or ends with a dot
            const newInput = parseFloat(input)
            if (newInput > claimPower) {
                setClaimValue(claimPower.toString())
            } else {
                setClaimValue(input)
            }
        } else if (input === '') {
            setClaimValue('')
        }
    }

    const handleSelectClaimArtHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptions = Array.from(event.target.selectedOptions)
        let found = false
        for (const option of selectedOptions) {
            const selectedArt = portfolioData.find((art) => art.tokenId === parseInt(option.value))
            if (selectedArt) {
                setCastingArtId(selectedArt.art.id)
                setClaimPower(selectedArt.claimPower)
                found = true
                break
            }
        }
        if (!found) {
            setClaimValue('0')
            setClaimPower(0)
        }
    }

    return (
        <div className="nft-container artwork-box">
            <span>Your NFT&apos;s</span>
            <select required={true} multiple={false} onChange={handleSelectClaimArtHandler}>
                <option key={'first'} title={'first'}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{' - Select your NFT -'}
                </option>
                {artData.tokenId && portfolioDataOptions(portfolioData, currentAccount, artData.tokenId)}
            </select>
            <input
                type="range"
                min="0"
                max={claimPower.toFixed(2)}
                step="0.01"
                value={parseFloat(claimValue) || 0}
                onChange={(event) => setClaimValue(parseFloat(event.target.value).toFixed(2))}
            />
            <input
                type="text"
                min="0"
                max={claimPower.toFixed(2)}
                value={claimValue}
                onChange={handleClaimInputChange}
            />
            <Button
                btnName={`Claim`}
                classStyles={'nav__medium '}
                disabled={!accountSignature || !claimPower}
                handleClick={() =>
                    accountSignature
                        ? claimHandler(castingArtId, artData, parseFloat(claimValue))
                        : alert('Please connect your wallet to proceed transaction')
                }
                cancelBg={undefined}
            />
        </div>
    )
}
export default Claim
